import React, { useEffect, useState } from "react";
import Head from "../layout/head/Head";
import Content from "../layout/content/Content";
import { useForm } from "react-hook-form";
import { Block, Col, PreviewAltCard, Row } from "../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import {
  listMostSearchAPI,
  createMostSearchAPI,
  updateMostSearchAPI,
  approveMostSearchAPI,
} from "../api/master/indes";
import Select from "react-select";
import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../assets/constants";

import MyButton from "../MyComp/UI/form/MyButton";
import ViewImage from "../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../MyComp/UI/modals/ConfirmModal";
import MyInput from "../MyComp/UI/form/MyInput";
import Status from "../MyComp/UI/form/Status";
import Table from "../MyComp/UI/DataTable/Table";
import useLogout from "../hooks/useLogout";
import MySelect from "../MyComp/UI/form/MySelect";

const MostSearch = () => {
  const logout = useLogout();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      name: "",
      status: "",
      selectedRow: null,
      image_preview: null,
      isPub: false,
    },
  });

  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");

  const isLoading = watch("isLoading");

  // ---------------- Fetch list ----------------
  useEffect(() => {
    getMostSearchList();
  }, []);

  const getMostSearchList = () => {
    setValue("isLoading", true);
    listMostSearchAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
        } else {
          setData([]);
          toast.error(res.data.message);
        }
        setValue("isLoading", false);
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  // ---------------- Offcanvas form ----------------
  const toggleCanvas = () => {
    setIsOpen(!isOpen);
    if (isOpen) resetForm();
  };

  const resetForm = () => {
    setValue("name", "");
    setValue("status", "");
    setMode("Add");
  };

  const onFormSubmit = () => {
    setValue("isLoading", true);
    const body = {
      name: watch("name"),
      status: watch("status")?.value,
      ...(mode === "Edit" && { id: watch("selectedRow")?.id, old_name: watch("selectedRow")?.name, }),
    };
    const apiCall = mode === "Add" ? createMostSearchAPI : updateMostSearchAPI;

    apiCall(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          getMostSearchList();
          setIsOpen(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
        setValue("isLoading", false);
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleEdit = (row) => {
    setValue("selectedRow", row);
    setValue("name", row?.name);
    setValue(
      "status",
      row.status == "approved"
        ? { label: "Approved", value: "approved" }
        : row.status == "rejected"
          ? { label: "Rejected", value: "rejected" }
          : null
    );
    setMode("Edit");
    setIsOpen(true);
  };

  const confirmStatusChange = () => {
    const row = watch("selectedRow");
    const body = { id: row.id, status: !row.status };
    updateMostSearchAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          getMostSearchList();
          setShowModal(false);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const handleApproveReject = (row, action) => {
    const body = { id: row.id, name: row?.name, old_name: row?.name, status: action };
    updateMostSearchAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.success("Approved successfully");
          getMostSearchList();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });

  };

  const handleImageClose = () => setImageOpen(false);

  return (
    <>
      <Head title="Most Search | Master" />

      <Content>
        <Block>

          {/* ---------------- Offcanvas Form ---------------- */}
          <Offcanvas isOpen={isOpen} direction="end">
            <OffcanvasHeader toggle={toggleCanvas}>
              {mode === "Add" ? "Add Most Search" : "Edit Most Search"}
            </OffcanvasHeader>

            <OffcanvasBody>
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row>
                    {/* Name input */}
                    <Col md="12">
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title="Name"
                        name="name"
                        placeholder="Enter name"
                        required
                        min={2}
                        max={50}
                      />
                    </Col>

                    {/* Show Approve/Reject select only in Edit mode */}
                    {mode === "Edit" && (
                      <Col md="12" className={``}>
                        <MySelect
                          register={register}
                          watch={watch}
                          trigger={trigger}
                          errors={errors}
                          name="status"
                          placeholder="Select Status"
                          options={[
                            { value: "approved", label: "Approved" },
                            { value: "rejected", label: "Rejected" },
                          ]}
                          required
                          title="Status"
                          setValue={(name, value) => setValue(name, value)}
                          value={watch("status")}
                        />
                      </Col>
                    )}

                    <Col md="12" className="mt-4">
                      <MyButton isLoading={isLoading} mode={mode} />
                    </Col>
                  </Row>
                </Form>
              </PreviewAltCard>
            </OffcanvasBody>
          </Offcanvas>

          <Table
            title="Most Search List"
            data={data}
            columns={[
              { key: "name", label: "Name" },
              { key: "count", label: "Count" },
            ]}
            searchKeys={["name"]}
            nameColumn={"name"}
            isLoading={isLoading}
            onEditClick={handleEdit}
            statusFilterEnabled={false}
            approveRejectEnabled={true}
            handleApproveReject={handleApproveReject}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            resetF={reset}
            toggleCanvas={toggleCanvas}
            addButton={false}
          />

        </Block>
      </Content>
      <ViewImage
        url={watch("image_preview")}
        imageOpen={imageOpen}
        handleImageClose={handleImageClose}
      />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default MostSearch;